import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../reducers/painelAlerta.actions";
import {
  getFiltrosTop,
  getOs,
} from "../../../../selectors/painelAlerta.selectors";
import HeaderTopAlerts from "./HeaderTopAlerts";

const HeaderTopAlertsConnected = () => {
  const dispatch = useDispatch();
  const filtros = useSelector(getFiltrosTop);
  const osFile = useSelector(getOs);

  const handleClickOpenFilters = useCallback(() => {
    dispatch(actions.exibirFiltrosTop(true));
  }, [dispatch]);

  const handleDownloadCsv = useCallback(() => {
    dispatch(actions.downloadOs.request());
  }, [dispatch]);

  const handleCleanOsData = useCallback(() => {
    dispatch(actions.cleanOsData());
  }, [dispatch]);

  return (
    <HeaderTopAlerts
      handleDownloadCsv={handleDownloadCsv}
      cliente={
        filtros?.empresa?.nome ? filtros?.empresa?.nome : filtros.empresaNome
      }
      inicioPeriodo={filtros.inicioPeriodo}
      fimPeriodo={filtros.fimPeriodo}
      handleClickOpenFilters={handleClickOpenFilters}
      loading={osFile.loading}
      osFile={osFile}
      handleCleanOsData={handleCleanOsData}
    />
  );
};

export default HeaderTopAlertsConnected;
